import api from '@/services/api';

export default {
    async createAccount({dispatch, commit}, accountData) {
        const {data} = await api.post('/api/account/create-account', accountData);
        if (data.success) {
            dispatch('getAccounts');
        }
        return data;
    },
    async getAccounts({commit}, params) {
        params = params ? params : { page: 1 }
		const {data} = await api.get('/api/account/get-accounts', {params});
        if (data.success) {
            commit('SETNUMBEROFRESULTS', data.numberOfResults);
            commit('SETACCOUNTS', data.data);
        }
        return data;
	},
	async resetPassword({dispatch, commit}, accountData) {
		const {data} = await api.put('/api/account/change-account-password', accountData);
		return data;
    },
    async updateAccount({dispatch, commit}, updateData) {
        const {data} = await api.put('/api/account/update-account', updateData);
        if (data.success) {
            dispatch('getAccounts');
        }
		return data;
    },
}